import type { ApiHealthResponse } from './types';

function isDatabaseUp(data: ApiHealthResponse): boolean {
  const databaseStatus =
    data.details?.database?.status ?? data.info?.database?.status;

  return databaseStatus === 'up';
}

export function isApiReady(data: ApiHealthResponse | undefined): boolean {
  if (!data) {
    return false;
  }

  return data.status === 'ok' && isDatabaseUp(data);
}
